import * as shop from "./shop";

export const console = {
    ...shop,
};